import React from "react";
import PaymentSkeleton from "../skeleton/payment";
import { numberWithCommas } from "../helpers";
import Image from "../../assets/images/emptyState/single-food.jpg";
import Placeholder from "../../assets/images/icons/scout-search.svg";

export default function SearchResultsModal({
  searching,
  searchApplication,
  searchValue,
  showMobileInput = false,
  onSearchChange,
}) {
  const onSearchImageError = (e) => {
    e.target.src = Image;
  };

  const hasResults =
    searchApplication?.data?.products?.length > 0 ||
    searchApplication?.data?.outlets?.length > 0;

  return (
    <div className="absolute left-0 right-0 w-full bg-white dark:bg-[#121212] z-20 shadow shadow-xl max-w-full sm:max-w-[1050px] mx-auto">
      {/* Mobile search input */}
      {showMobileInput && (
        <div className="block sm:hidden">
          <label htmlFor="mobile-search" className="sr-only">
            Search
          </label>
          <div className="relative">
            <input
              id="mobile-search"
              name="search"
              className="block w-full bg-[#F7F7F7] border-none rounded-xs py-3 px-4 placeholder-[#676565] focus:outline-none focus:ring-primary focus:border-primary focus:text-[#676565] focus:placeholder-gray-400 text-[16px]"
              placeholder="Search"
              type="search"
              autoComplete="off"
              defaultValue={searchValue}
              onChange={onSearchChange}
            />
          </div>
        </div>
      )}

      {/* Search results */}
      <div className="px-6 py-6">
        {searching ? (
          <PaymentSkeleton />
        ) : hasResults ? (
          <div className="grid grid-cols-1 sm:grid-cols-10 sm:gap-8 gap-16">
            {/* Outlets */}
            <div className="sm:col-span-3">
              <h5 className="text-[#91929D] mb-2">Outlets</h5>
              {searchApplication?.data?.outlets?.length > 0 ? (
                <ul className="grid grid-cols-1 gap-4 sm:max-h-[450px] overflow-scroll">
                  {searchApplication.data.outlets.map((item, index) => (
                    <a
                      key={index}
                      href={
                        item?.store_name
                          ? `/store/${item?.id}`
                          : `/restaurant/${item?.id}`
                      }
                    >
                      <li className="flex gap-3 items-center cursor-pointer">
                        <img
                          src={
                            (item?.restaurant_pictures?.[0] ||
                              item?.store_pictures?.[0]) ??
                            Image
                          }
                          className="h-[32px] w-[32px] object-cover rounded-[4px]"
                          alt="outlet"
                          onError={onSearchImageError}
                        />
                        <div>
                          <h4 className="capitalize">
                            {item?.restaurant_name || item?.store_name}
                          </h4>
                          <p className="uppercase text-xs">
                            <span>
                              {item?.restaurant_name ? "Restaurant" : "Store"}
                            </span>
                            <span> {">"} </span>
                            <span>
                              {item?.restaurant_city || item?.store_city}
                            </span>
                          </p>
                        </div>
                      </li>
                    </a>
                  ))}
                </ul>
              ) : (
                <p>No outlets found</p>
              )}
            </div>

            {/* Products */}
            <div className="sm:col-span-7">
              <h5 className="text-[#91929D] mb-2">Products</h5>
              {searchApplication?.data?.products?.length > 0 ? (
                <ul className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6 sm:max-h-[450px] overflow-scroll">
                  {searchApplication.data.products.map((item, index) => (
                    <a
                      key={index}
                      href={
                        item?.merchandise_name
                          ? `/store/${item?.store_id}?item=${item?.id}`
                          : `/restaurant/${item?.restaurant_id}?item=${item?.id}`
                      }
                    >
                      <li className="card cursor-pointer">
                        <img
                          src={
                            (item?.food_pictures?.[0] ||
                              item?.merchandise_pictures?.[0]) ??
                            Image
                          }
                          className="h-[110px] w-full mb-2 object-cover rounded-[4px]"
                          alt="product"
                          onError={onSearchImageError}
                        />
                        <h5 className="uppercase text-xs mb-1">
                          {item?.food_name || item?.merchandise_name}
                        </h5>
                        <p className="mb-1 text-sm">
                          {item?.food_name || item?.merchandise_name}
                        </p>
                        <p className="font-bold text-[#333333] dark:text-[#BCBCBC]">
                          ₦
                          {numberWithCommas(item?.food_amount) ||
                            numberWithCommas(item?.merchandise_amount)}
                        </p>
                      </li>
                    </a>
                  ))}
                </ul>
              ) : (
                <p>No products found</p>
              )}
            </div>
          </div>
        ) : (
          <div className="p-4 max-w-[290px] mx-auto text-center">
            <img src={Placeholder} className="mx-auto my-8" alt="search" />
            {searchValue?.length >= 3 ? (
              <>
                <p className="text-[#23263B] font-bold tracking-sm mb-3">
                  Sorry, we didn't find any matches for "{searchValue}"
                </p>
                <p className="text-[14px]">
                  Try different keywords and make sure all words are spelled
                  correctly!
                </p>
              </>
            ) : (
              <p className="text-[14px]">
                Search for a food, merchandise, store or restaurant
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
